module.exports = __webpack_public_path__ + "static/media/play-market.faae3d5e.png";